import React from 'react';
import { AddToCartButton } from '../addToCartButton/AddToCartButton';

export const OrderAPackageBuyBox = (props) => {
  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <AddToCartButton {...props} />

  );
};
OrderAPackageBuyBox.displayName = 'OrderAPackageBuyBox';
